export const BANK_TRANSFER_INFO = {
  bankName: 'SMBC',
  branchName: 'トランクNORTH支店',
  accountType: '普通',
  accountNumber: '304884',
  accountHolder: 'カ）ロフ',
};
